import React from 'react';
import TimeToTimeInput from '../../../../components/time-to-time-input/TimeToTimeInput';

export default (props) => {
    const {
        key,
        name,
        value,
        forcedValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <TimeToTimeInput
        value={forcedValue}
        defaultValue={value}
        onChange={onChange}
        hasSeconds={options.hasSeconds}
    />;
}
